@if (displayFlag) {
  <div class="info-banner-card">
    <mat-card-content [ngClass]="style ?? 'accent'">
      @if (isAdminOrSuperAdminFlag) {
        <span class="info-banner-recipient">Message espaces laboratoires</span>
      }
      @if (style === 'maintenance') {
        <mat-icon class="info-banner-icon s-20" svgIcon="svg_maintenance"></mat-icon>
      }
      @if (style === 'new') {
        <mat-icon class="info-banner-icon s-20" svgIcon="svg_new"></mat-icon>
      }
      <span>{{ text }}</span>
      @if (textLink && link) {
        <a [href]="link" class="info-banner-link text-nowrap" mat-menu-item target="_blank">{{ textLink }}</a>
      }
      <button
        (click)="close()"
        [attr.aria-label]="'Ne plus afficher ce message'"
        class="info-banner-close-button small-icon-button"
        mat-icon-button
        matTooltip="Ne plus afficher ce message"
        type="button"
      >
        <mat-icon class="s-20">close</mat-icon>
      </button>
    </mat-card-content>
  </div>
}
